import { render, staticRenderFns } from "./MyProfile.view.vue?vue&type=template&id=6e7e7c22&scoped=true"
import script from "./MyProfile.view.vue?vue&type=script&lang=js"
export * from "./MyProfile.view.vue?vue&type=script&lang=js"
import style0 from "./MyProfile.view.vue?vue&type=style&index=0&id=6e7e7c22&prod&lang=scss"
import style1 from "./MyProfile.view.vue?vue&type=style&index=1&id=6e7e7c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7e7c22",
  null
  
)

export default component.exports